import React, { useRef, useState } from "react"
import { faq } from "../../dummydata"
import Heading from "../common/heading/Heading"

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null)

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <section className="faq-section">
      <div className="container">
        <Heading subtitle='Frequently Asked Questions' title='Everything You Need to Know' />
        
        <div className="faq-container">
          {faq.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question" 
                onClick={() => toggle(index)}
                aria-expanded={activeIndex === index}
              >
                <span className="question-text">{item.title}</span>
                <svg 
                  className={`chevron-icon ${activeIndex === index ? 'rotated' : ''}`}
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              <div className={`faq-answer ${activeIndex === index ? 'expanded' : ''}`}>
                <div className="answer-content">
                  <p>{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-footer">
          <p>Still have questions? We're here to help!</p>
          <button className="contact-support-btn">Contact Support</button>
        </div>
      </div>
    </section>
  )
}

export default Faq
